/** Generic provider to game window Event */
export enum GenericEvents {
  ALERT_ACTION = 'alertAction',
  APPLICATION_READY = 'gameReady',
  AUTOPLAY_STOP = 'stopAutoSpin',
  AUTOPLAY_RESUME = 'resumeAutoSpin',
  BACK_TO_PARTNER = 'backToPartner',
  CLOSE = 'close',
  GAME_LOAD_END = 'gameLoadEnd',
  GAME_LOAD_PROGRESS = 'gameLoadProgress',
  GAME_LOAD_START = 'gameLoadStart',
  INITIALIZATION_REQUEST = 'initializationRequest',
  MACHINE_LOAD_ENDED = 'gameLoadingEnded',
  RELOAD_BALANCE = 'updateBalance',
  RESTART_GAME = 'restartGame',
  SHOW_DEPOSIT = 'showDeposit',
  SOUND_OFF = 'soundOff',
  SOUND_ON = 'soundOn',
  TOGGLE_SOUND = 'toggleSound',
  SPIN_IN_PROGRESS = 'gameRoundStart',
  SPIN_IN_PROGRESS_ENDED = 'gameRoundEnd',
  TOGGLE_PAYTABLE = 'togglePaytable',
  TOGGLE_HELP = 'toggleHelp',
  NOTIFICATION = 'notifyWrapperStateChange',
  NOTIFICATION_HANDLED = 'notifyWrapperMessageHandled',
  ERROR_CONNECTION = 'errorConnection',
  ERROR_GENERIC = 'errorGeneric',
  ERROR_INSUFFICIENT_FUNDS = 'errorInsufficientFunds',
  ERROR_LIMITS = 'errorLimits',
  ERROR_AUTHENTICATION = 'errorAuthentication',
  ERROR_DELEGATION = 'errorDelegation',
  DISMISS_ERROR = 'dismissError',
}

export type ExtendableGenericEvents =
  | GenericEvents
  | (string & Record<never, never>);

export interface GenericErrorEvent {
  type: string;
  error?: string;
  code?: string;
  message?: string;
  errorCode?: string;
  errorMessage?: string;
  description?: string;
  name?: string;
  level?: string;
  internalErrorCode?: string;
}

export interface GenericEventsData<P = unknown> {
  source?: string;
  type?: string;
  eventName?: string;
  updatedGameStatus?: string;
  stateChangeMessageType?: string;
  wrapperMessageType?: string;
  data?: P;
  errorInfo?: GenericErrorEvent;
  timestamp?: number;
  payload?: { [key: string]: string } | P;
  event?: string | Record<string, unknown>;
  rawEvent?: string;
  eventId?: string;
  eventType?: string;
  messageId?: string;
  messageType?: string;
  messageName?: string;
  version?: string;
}
